import { getCurrentShortLocale } from '@/lib/i18n/core/currentLanguage';

/**
 * エラーレスポンスの displayMessages から現在ロケールのメッセージを取り出す。
 * 該当ロケールが無ければ displayMessage にフォールバックする。
 */
export function resolveLocalizedDisplayMessage(data: {
  displayMessages?: Record<string, string>;
  displayMessage?: string;
}): string | undefined {
  return data.displayMessages?.[getCurrentShortLocale()] ?? data.displayMessage;
}
